import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Modal, Table } from 'react-bootstrap';
import { formatters as commonFormatters, TRANSFER_STATES } from 'common';
import { formatTransferStateDescription } from './formatters';
import styles from './styles.css';
import messages from './messages';

const TransferStateDescriptionModal = ({ show, onHide }) => (
  <Modal show={show} onHide={onHide}>
    <Modal.Header closeButton>
      <h2 className={styles.header}>
        <FormattedMessage {...messages.title} />
      </h2>
    </Modal.Header>
    <Modal.Body>
      <Table>
        <thead>
          <tr>
            <th>
              <FormattedMessage {...messages.transferStateHeader} />
            </th>
            <th>
              <FormattedMessage {...messages.descriptionHeader} />
            </th>
          </tr>
        </thead>
        <tbody>
          {TRANSFER_STATES.map((transferState) => (
            <tr key={transferState}>
              <td>{commonFormatters.formatTransferState(transferState)}</td>
              <td>{formatTransferStateDescription(transferState)}</td>
            </tr>
          ))}
        </tbody>
      </Table>
      <div className={styles.buttonWrapper}>
        <button onClick={onHide} className="buttons buttons-primary">
          <FormattedMessage {...messages.close} />
        </button>
      </div>
    </Modal.Body>
  </Modal>
);

TransferStateDescriptionModal.propTypes = {
  onHide: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
};

export default TransferStateDescriptionModal;



// WEBPACK FOOTER //
// ./src/components/TransferStateDescriptionModal/index.js